































































































































































import Super from "@/pv4-super-class"
import { Component } from "vue-property-decorator"

import { map } from "lodash"

import LoadingLogo from "@/components/LoadingLogo.vue"
import DataStoreEditor from "@/components/DataStoreEditor.vue"
import { BDialogConfig, BModalConfig } from "buefy/types/components"
import { AxiosRequestConfig } from "axios"
import DataStoresCreate from "@/views/Stats/DataStores/DataStoresCreate.vue"

interface DataStore {
  dataStoreID?: number
  dataStoreCode?: string
  dataStoreEnabled?: boolean
  dataStoreName?: string
  dataStoreJSON?: string
  dataStoreObject?: any
  dataStoreSecretPlainText?: string
}

type EventID = number | string | undefined

@Component({
  components: {
    DataStoreEditor,
    LoadingLogo
  }
})
export default class DataStoresList extends Super {
  dataStores: DataStore[] | null = null
  saved = true

  testData: any

  /**
   * Runs when the component is created.
   * Load Data Stores from API.
   */
  created(): void {
    this.loadDataStores(this.eventId)
  }

  /**
   * Mark the page as unsaved when a change is made
   */
  markUnsaved() {
    this.saved = false
  }

  /**
   * Mark the page as saved when an update is resolved
   */
  markSaved() {
    this.saved = true
  }

  /**
   * Load Data Stores from the API
   * @param {EventID} eventID - A valid PV4 Event ID
   */
  loadDataStores(eventId: EventID): void {
    this.http
      .get(`/data-store?eventID=${eventId}`)
      .then(res => (this.dataStores = res.data))
      .catch(this.displayError)
  }

  /**
   * Save changes to DataStore to the API
   * @param {EventID} eventId: A valid PV4 Event ID
   * @param {DataStore} dataStore: A valid PV4 Data Store Object
   */
  saveAllDataStores(eventId: EventID, dataStores: DataStore[]): void {
    const promises = map(dataStores, dataStore =>
      this.http.put(
        `/data-store/${dataStore.dataStoreID}?eventID=${eventId}`,
        dataStore
      )
    )

    Promise.all(promises)
      .then(() => this.loadDataStores(eventId))
      .then(this.markSaved)
      .catch(this.displayError)
  }

  //this.$buefy.toast.open({message: "Data Imported Sucessfully! Press 'Save All' to save to database", type:'is-success'})

  /**
   * Loads in data from an external URL then returns mesage to user if it has succeded or failed
   * @param dataStore - data store object
   * @param externalURL - external url
   * @param externalHeader - external header
   */
  loadExternalURL(dataStore, externalURL, externalHeader) {
    console.log(JSON.parse(externalHeader))
    const config: AxiosRequestConfig = JSON.parse(externalHeader)
    this.http
      .get(externalURL, config)
      .then(val => {
        dataStore.dataStoreObject = val.data
        this.$buefy.toast.open({
          message:
            "Data Successfully Pulled! Press Save All to Save to Database",
          type: "is-success",
          duration: 5000
        })
      })
      .then(() => (this.saved = false))
      .catch(error => {
        this.$buefy.toast.open({
          message: error,
          type: "is-danger",
          duration: 5000
        })
      })
  }

  /**
   * Create a new task
   */
  openDataStoreCreator() {
    const config: BModalConfig = {
      parent: this,
      component: DataStoresCreate,
      props: {
        eventId: this.eventId
      }
    }

    this.$buefy.modal
      .open(config)
      .$on("close", () => this.loadDataStores(this.eventId))
  }

  /**
   * Show a dialog with cloud push information
   */
  showCloudPushDialog(eventId: EventID, dataStore: DataStore) {
    const message = `
Send a <b>HTTP POST</b> request to<br/>
${this.orchestrateGateway}/data-store/${eventId}/${dataStore.dataStoreID}?strategy=(merge|overwrite)<br/>
<br/>
<code>body</code> should be the JSON data you wish to push.<br/>
<code>strategy</code> can be 'merge' or 'overwrite' to merge with existing data or overwrite it completely.<br/>
<code>Authorization</code> header should be "Bearer (secret key)"<br/>
<br/>
If you don't have your secret key, click the key icon to regenerate a new one - Note: this will invalidate your old secret key!<br/>
<br/>
curl -X POST "${this.orchestrateGateway}/data-store/${eventId}/${dataStore.dataStoreID}?strategy=merge"
     -H 'Authorization: Bearer xxxxxxxxxxxxxxxx'
     -H 'Content-Type: application/json; charset=utf-8'
     -d $'{"a_key": "a_key_value"}'
`

    const options: BDialogConfig = { title: "Cloud Push", message }
    this.$buefy.dialog.alert(options)
  }

  /**
   * Generate New Secret Key
   */
  showRotateSecretDialog(eventId: EventID, dataStore: DataStore) {
    const dataStoreID = dataStore.dataStoreID

    const options: BDialogConfig = {
      title: "Confirm",
      message:
        "Are you sure you want to generate a new secret?<br/>Your old secret will no longer be valid.",
      onConfirm: () => {
        this.http
          .patch(`/data-store/${dataStoreID}/rotate-secret?eventID=${eventId}`)
          .then(res => {
            const message = `
Your new secret key is:<br/>
<br/>
<pre style="word-wrap: break-word; ">${res.data.dataStoreSecretPlainText}</pre><br/>
<br/>
Please save this somewhere secure- if you lose it, you cannot recover it, and you will need to generate a new one`

            const options: BDialogConfig = {
              title: "New DataStore Secret Key",
              message
            }
            this.$buefy.dialog.alert(options)
          })
          .catch(this.displayError)
      }
    }
    this.$buefy.dialog.confirm(options)
  }
}
